export function checkRole (user, role) {
  try {
    return user.role_id == role
  } catch (err) {
    return false
  }
}

export function isAdmin (user) {
  return checkRole(user, 1)
}

export function isOrganizationLeader (user) {
  return checkRole(user, 2)
}

export function isProfessional (user) {
  return checkRole(user, 4)
}

export function isManager (user) {
  return checkRole(user, 3)
}

export function hasInBetweenPrivileges (user) {
  return isProfessional(user) || isOrganizationLeader(user) || isManager(user)
}

export function isRecipient (user) {
  return checkRole(user, 5)
}

export function canEditHealth (permissions) {
  return permissions.canEditHealth == 1
}
export function canEditSkills (permissions) {
  return permissions.canEditSkills == 1
}
export function canEditLifeContext (permissions) {
  return permissions.canEditLifeContext == 1
}
export function canEditPerceptionReport (permissions) {
  return permissions.canEditPerceptionReport == 1
}

export function isCurrentUser (user, current) {
  return user && current && user.id == current.id
}



// WEBPACK FOOTER //
// ./resources/js/plugins/auth.js